"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Meta", {
    enumerable: true,
    get: function() {
        return Meta;
    }
});
var _loadMeta = require("./loadMeta");
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Meta = function Meta(config) {
    "use strict";
    var _this = this;
    _class_call_check(this, Meta);
    _define_property(this, "fbq", void 0);
    _define_property(this, "revenue", function(price, quantity, type) {
        var productId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '1', currency = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 'USD';
        if (type.toLowerCase() !== 'new') {
            _this.fbq('track', 'InitiateCheckout', {
                content_type: 'product',
                contents: [
                    {
                        id: productId,
                        quantity: quantity
                    }
                ],
                value: price,
                currency: currency
            });
        } else {
            _this.fbq('track', 'Purchase', {
                content_type: 'product',
                contents: [
                    {
                        id: productId,
                        quantity: quantity
                    }
                ],
                value: price,
                currency: currency
            });
        }
    });
    _define_property(this, "track", function(eventName) {
        var traits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        _this.fbq('trackCustom', eventName, traits);
    });
    // Not supported
    _define_property(this, "identify", function() {});
    _define_property(this, "page", function() {}) // Each time the Pixel loads, it automatically calls fbq('track', 'PageView') to track a PageView standard event
    ;
    _define_property(this, "group", function() {});
    _define_property(this, "reset", function() {});
    var $fbq = (0, _loadMeta.setup)().init(config.pixelAccountId).$fbq;
    this.fbq = $fbq;
};
